export const generateBasicAuth = (username: string, password: string) => {
    const id = username + ':' + password;
    return btoa(id);
};

/**
 * Generate security tick
 *
 * @returns {string}
 */
export const generateTick = (): string => {
    const id = 'FIT9f42edc7829e46429aebf0d0dc17af93';
    const date = Date.now();
    const ticks = date * 10000 + 621356220000000000;
    return btoa(id + ':' + ticks);
};
